import React from "react";
import { withApollo } from "react-apollo";
import {
  getListOfAttachmentsForSubcategoryByUserId,
  downloadAttachment,
  downloadBulkSubCatAttachment,
  sendEmailForDoc,
} from "../../../services/graphql/queries/category-management";
import { errorMessage } from "../../../miscellaneous/error-messages";
import { errorMsg, successMsg } from "../../../miscellaneous/react-toastify";

import DisplayErrors from "../../Common/DisplayErrors";

import { SET_TIMEOUT_VALUE } from "../../../constants/app-constants";

import downloadSvg from "../../../static/images/download.svg";
import whiteDownloadSvg from "../../../static/images/whiteDownloadSvg.svg";
import gridSvg from "../../../static/images/grid.svg";
import config from "../../../config";
import Emailnotify from "../../../static/images/EmaildownBtn.svg";
import { GET_PERMISSION } from "../../../services/graphql/queries/accessPermission";
import { addPermission } from "../../../services/redux/actions/loginActions";
import Modal from "react-awesome-modal";
import popupLogo from "../../../static/images/popup-logo.png";
import InputComponent from "../../Common/form-component/InputComponent";
import ReactModal from "../../MobileCommon/ReactModal";
import SimpleReactValidator from "simple-react-validator";
import { MdOutlineFileDownload } from "react-icons/md";

const FileSaver = require("file-saver");
const mime = require("mime-types");

class Attachments extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      category: props.category,
      loading: false,
      errors: [],
      attachments: [],
      isSelectAll: false,
      downloadAttachmentArr: [],
      accessPermission: [],
      modalVisibleEmail: false,
      emailProvider: {
        inputEmail: "",
        // emails: "",
      },
      emailAttachment: {},
      reactModalVisible: false,
      modalMessage: "Email sent Successfully",
      sending: false,
      loadingDownload:false,
      downloadingAttachments:{}
    };
    this.validator = new SimpleReactValidator({
      validators: {
        multipleEmails: {
          message: "Please enter valid email addresses",
          rule: (value) => {
            if (!value) return false; // Required field check
            const emailPattern = /^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/;
            // Split emails, trim spaces, and validate each one
            // Convert value to string in case it's not
            const strValue = String(value);
            const emails = strValue.split(",").map((email) => email.trim());
            return emails.every((email) => emailPattern.test(email));
          },
          required: true, //This ensures that the field must be filled in
        },
      },
      element: (message) => (
        <div style={{ color: "red", fontSize: "14px", marginTop: "5px" }}>
          {message}
        </div>
      ),
    });
  }

  // onClickOfAttachment(attachment) {
  //   console.log("onClickOfAttachment attachment", attachment);
  //   if (attachment.attachmentType == 1) {
  //     this.setState((prevState) => ({
  //       downloadingAttachments: {
  //         ...prevState.downloadingAttachments,
  //         [attachment.id]: true, // Set only the clicked attachment as downloading
  //       },
  //     }));
  //     this.props.client
  //       .mutate({
  //         mutation: downloadAttachment,
  //         variables: {
  //           attachmentId: attachment.id,
  //         },
  //         fetchPolicy: "no-cache",
  //       })
  //       .then((result) => {
  //         console.log("attachment res", result);
  //         let document = result.data.downloadSubCatAttachment;
  //         var byteCharacters = atob(document.fileData);

  //         var byteNumbers = new Array(byteCharacters.length);
  //         for (var i = 0; i < byteCharacters.length; i++) {
  //           byteNumbers[i] = byteCharacters.charCodeAt(i);
  //         }

  //         var byteArray = new Uint8Array(byteNumbers);

  //         const contentType = mime.lookup(document.fileName.split(".")[1]);

  //         var blob = new Blob([byteArray], {
  //           type: contentType,
  //         });

  //         FileSaver.saveAs(blob, document.fileName.substr(32));

  //         this.setState({
  //           errors: [],
  //           loading: false,
  //         });
  //         this.setState((prevState) => ({
  //           downloadingAttachments: {
  //             ...prevState.downloadingAttachments,
  //             [attachment.id]: false, // Reset only the clicked attachment/download File
  //           },
  //         }));
  //       })
  //       .catch((error) => {
  //         console.log("~~~error: ", error);
  //         this.setState({ loading: false, errors: [errorMessage(error)] });
  //         this.setState((prevState) => ({
  //           downloadingAttachments: {
  //             ...prevState.downloadingAttachments,
  //             [attachment.id]: false, 
  //           },
  //         }));
  //         this.timer = setTimeout(() => {
  //           this.setState({ errors: [] });
  //         }, SET_TIMEOUT_VALUE);
  //       });
  //   } else {
  //     let data = { GridId: attachment.gridId.id };
  //     localStorage.setItem("GridId-Input", JSON.stringify(data));
  //     // this.props.history.push("/grid-input-edit");
  //     // window.open("/grid-input-edit");
  //   }
  // }
  onClickOfAttachment(attachment) {
    if (attachment.attachmentType == 1) {
      this.setState((prevState) => ({
        downloadingAttachments: {
          ...prevState.downloadingAttachments,
          [attachment.id]: true, // Set only the clicked attachment as downloading
        },
        isDownloading:true
      }));
      // successMsg("Downloading File, please wait...");

      this.props.client
        .mutate({
          mutation: downloadAttachment,
          variables: {
            attachmentId: attachment.id,
          },
          fetchPolicy: "no-cache",
        })
        .then(async(result) => {

          let attachmentData = result.data.downloadSubCatAttachment;

          let presignedUrl = attachmentData?.fileData; // Get pre-signed URL

          let fileName = attachmentData?.fileName;

          if (!presignedUrl || !fileName) {
            console.error("Presigned URL or filename is missing!");
            this.setState({ isDownloading: false });
            return;
          }
    
          // Modify filename by removing the first 32 characters
          let modifiedFileName = fileName.length > 32 ? fileName.substr(32) : fileName;

          let link = document.createElement("a");
          link.href = presignedUrl;
          link.setAttribute("download", modifiedFileName); 
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);

          successMsg("Download Initiated");
          this.setState({
            errors: [],
            loading: false,
            isDownloading:false
          });
          this.setState((prevState) => ({
            downloadingAttachments: {
              ...prevState.downloadingAttachments,
              [attachment.id]: false, // Reset only the clicked attachment/download File
            },
          }));
        })
        .catch((error) => {
          console.log("~~~error: ", error);
          let message = errorMessage(error);
          errorMsg(message[0]);
          this.setState({
            loading: false,
            errors: [errorMessage(error)],
          });
          setTimeout(() => {
            this.setState({ isDownloading: false });
          }, 3000);
          this.setState((prevState) => ({
            downloadingAttachments: {
              ...prevState.downloadingAttachments,
              [attachment.id]: false, 
            },
          }));
          this.timer = setTimeout(() => {
            this.setState({ errors: [] });
          }, SET_TIMEOUT_VALUE);
        });
    } else {
      let data = { GridId: attachment.gridId.id };
      localStorage.setItem("GridId-Input", JSON.stringify(data));
      // this.props.history.push("/grid-input-edit");
      // window.open("/grid-input-edit");
    }
  }

  downloadBulkSubCatAttachment() {
    if (this.state.loadingDownload) return;

    this.setState({ loadingDownload: true ,isDownloading:true});
    const { isSelectAll, downloadAttachmentArr, attachments } = this.state;
    let attachmentArr = [];
    // if (isSelectAll) {
       attachmentArr = downloadAttachmentArr;
    // } else {
    //   for (let i = 0; i < attachments.length; i++) {
    //     if (attachments[i].attachmentType == 1 && attachments[i].canDownload)
    //       attachmentArr.push(attachments[i].id);
    //   }
    // }
    // if (!attachmentArr.length) {
    //   this.setState({
    //     errors: ["Please select atleast one attachment to download."],
    //     loadingDownload: false,
    //     isDownloading:false
    //   });
    //   this.timer = setTimeout(() => {
    //     this.setState({ errors: [] });
    //   }, SET_TIMEOUT_VALUE);
    //   return;
    // }
    this.setState({ loading: true });
    // successMsg("Downloading File, please wait...");
    this.props.client
      .mutate({
        mutation: downloadBulkSubCatAttachment,
        variables: {
          subCategoryId: this.state.category.id,
          attachmentArr: attachmentArr,
        },
        fetchPolicy: "no-cache",
      })
      .then((result) => {
        let attachmentData = result.data.downloadBulkSubCatAttachment;
        let presignedUrl = attachmentData?.fileData; // Get pre-signed URL
        let fileName = attachmentData?.fileName;
        if (!presignedUrl || !fileName) {
          console.error("Presigned URL or filename is missing!");
          this.setState({ isDownloading: false ,loadingDownload:false});
          return;
        }

        let link = document.createElement("a");
        link.href = presignedUrl;
        link.setAttribute("download", fileName); 
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        this.getListOfAttachments();
        successMsg("Download Initiated");
        this.setState({
          errors: [],
          loading: false,
          isSelectAll: false,
          isDownloading:false,
          loadingDownload: false,
        });
      })
      .catch((error) => {
        console.log("~~~error: ", error);
        let message = errorMessage(error);
        errorMsg(message[0]);
        this.setState({ loading: false, errors: [errorMessage(error)],loadingDownload: false,isDownloading:false });
        this.timer = setTimeout(() => {
          this.setState({ errors: [] });
        }, SET_TIMEOUT_VALUE);
      });
  }

  getListOfAttachments() {
    this.setState({ loading: true });
    this.props.client
      .query({
        query: getListOfAttachmentsForSubcategoryByUserId,
        variables: {
          subCategoryId: this.props.category.id,
        },
        fetchPolicy: "network-only",
      })
      .then((result) => {
        var attachments =
          result.data.getListOfAttachmentsForSubcategoryByUserId;
        let downloadAttachmentArr = [];
        for (let i = 0; i < attachments.length; i++) {
          attachments[i].canDownload = false;
          if (attachments[i].attachmentType == 1) {
            downloadAttachmentArr.push(attachments[i].id);
          }
        }

        this.initialState = {
          attachments: attachments,
          downloadAttachmentArr: downloadAttachmentArr,
        };
        this.setState({ ...this.initialState, loading: false, error: "" });
      })
      .catch((error) => {
        this.setState({
          loading: false,
          error: error.message,
          attachments: [],
          downloadAttachmentArr: [],
        });
      });
  }

  isSelectAll(e) {
    var attachments = this.state.attachments;

    for (let i = 0; i < attachments.length; i++) {
      if (e.target.checked) attachments[i].canDownload = true;
      else attachments[i].canDownload = false;
    }

    this.initialState = {
      attachments: attachments,
    };
    this.setState({ ...this.initialState, isSelectAll: e.target.checked });
  }

  isAttachmentDownloadable(e, attachmentData, index) {
    const { isSelectAll, attachments } = this.state;
    if (isSelectAll) return;
    attachments[index].canDownload = e.target.checked;
    this.setState({ attachments: attachments });
  }
  getPermission() {
    this.props.client
      .query({
        query: GET_PERMISSION,
        fetchPolicy: "network-only",
      })
      .then((result) => {
        console.log(
          "notify permission in mobile ",
          JSON.parse(result.data.getPermission)
        );
        this.setState(
          {
            accessPermission: JSON.parse(result.data.getPermission),
            //loading: true,
          },

          () => {
            console.log(
              "Updated accessPermission in mobile",
              this.state.accessPermission
            );
            
           // this.props.dispatch(addPermission(this.state.accessPermission));
          }
        );
      })
      .catch((error) => {
        this.props.dispatch(addPermission({}));
        console.log("~~~error: ", error);
      });
  }
  onModalForEmail(attachment) {
    this.setState({
      modalVisibleEmail: !this.state.modalVisibleEmail,
      emailAttachment: attachment,
    });
  }
  submitModal = () => {
    this.setState({ reactModalVisible: false, modalMessage: "" });

    // this.props.onUpdateUser();
  };
  // handleChange=(e)=>{
  //       this.setState((prev)=>({
  //         emailProvider:{
  //           ...prev.emailProvider,
  //           inputEmail:e.target.value
  //         }
  //       }));
  //       this.validator.showMessages("inputEmail"); // Force validation message update
  // }
  handleChange = (e) => {
    const { value } = e.target;
    this.setState((prevState) => ({
      emailProvider: {
        ...prevState.emailProvider,
        inputEmail: value, // Update email input
      },
    }));
      this.validator.showMessages("inputEmail"); // Force validation message update
  };
  onEmailCancelModalVisible() {
    let emailProvider = {
      inputEmail: [],
    };
    this.validator.hideMessages();
    this.setState(
      {
        modalVisibleEmail: !this.state.modalVisibleEmail,
        emailProvider: emailProvider,
      }
    );
  }

  // sendEmail(emailAttachment) {
  //   if (this.validator.allValid()) {
  //     //console.log("attachment" + emailAttachment);
  //     const emailList = this.state.emailProvider.inputEmail
  //       .split(",")
  //       .map((email) => email.trim());
  //     // const emailList = this.state.emailProvider.inputEmail
  //     let emailProvider = {
  //       inputEmail: "",
  //     };
  //     // console.log("Final Email List:", emailList);
  //     // console.log("jakson");
  //     this.validator.hideMessages()
  //     this.setState({
  //       loading: true,
  //       modalVisibleEmail: false,
  //       emailProvider,
  //       sending: true,
  //     });
  //     this.props.client
  //       .query({
  //         query: sendEmailForDoc,
  //         variables: {
  //           attachmentId: emailAttachment.id,
  //           attachmentName: emailAttachment.name,
  //           emailUsers: emailList,
  //         },

  //         fetchPolicy: "network-only",
  //       })
  //       .then(() => {
  //         this.setState({
  //           reactModalVisible: true,
  //           modalMessage: "Email sents successfully",
  //         });
  //       })
  //       .catch((error) => {
  //         console.log("~~~error: ", error);
  //         // let message = errorMessage(error);
  //         // errorMsg(message[0]);
  //         // this.setState({ loading: false, errors: [errorMessage(error)] });
  //         // this.timer = setTimeout(() => {
  //         //   this.setState({ errors: [] });
  //         // }, SET_TIMEOUT_VALUE);
  //       });
  //   } else {
  //     this.validator.showMessages();
  //     this.forceUpdate();
  //   }
  // }

  sendEmail(emailAttachment) {
      if (this.validator.allValid()) {
        const emailList = this.state.emailProvider.inputEmail
          .split(",")
          .map((email) => email.trim());
  
        // Remove duplicate emails
        const uniqueEmailList = [...new Set(emailList)];
  
        let emailProvider = {
          inputEmail: "",
        };
  
        this.validator.hideMessages();
        this.setState({
          loading: true,
          modalVisibleEmail: false,
          emailProvider,
          sending: true,
        });
        this.setState({ sending: true, modalVisibleEmail: true }, () => {
          this.props.client
            .query({
              query: sendEmailForDoc,
              variables: {
                attachmentId: emailAttachment.id,
                attachmentName: emailAttachment.name,
                emailUsers: uniqueEmailList,
              },
  
              fetchPolicy: "network-only",
            })
            .then((result) => {
              if (result?.data) {
                let responseMessage = JSON.parse(
                  result?.data?.sendEmailforDocument
                );
                let msg = responseMessage?.message;
                if (msg.includes("Emails sent successfully")) {
                  msg="Email/s sent successfully"
                  this.setState({
                    reactModalVisible: true,
                    sending: false,
                    modalVisibleEmail: false,
                    modalMessage: <span style={{ color: "green" }}>{msg}</span>,
                  });
                } else {
                  this.setState({
                    reactModalVisible: true,
                    sending: false,
                    modalVisibleEmail: false,
  
                    modalMessage: <span style={{ color: "red" }}>{msg}</span>,
                  });
                }
              }
            })
            .catch((error, result) => {
              console.log("~~~error:send email ", error);
  
              let message = errorMessage(error);
  
              // Extracting error message
              let errorMsgText = message[0];
              console.log("message", errorMsgText);
  
              this.setState({
                sending: false,
                loading: false,
                errors: [errorMsgText],
              });
  
              console.log("error", this.state.errors);
  
              this.timer = setTimeout(() => {
                this.setState({ errors: [] });
              }, SET_TIMEOUT_VALUE);
            });
        });
      } else {
        this.validator.showMessages();
        this.forceUpdate();
      }
    }

  componentDidMount() {
    this.getListOfAttachments();
    this.getPermission();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.category !== this.props.category) {
      //   this.getListOfAttachments();
      this.setState(
        { category: this.props.category, isSelectAll: false, attachments: [] },
        () => {
          this.getListOfAttachments();
          
        }
      );
    }
  }

  render() {
   // console.log("access perm",this.state.accessPermission);
    
    const {
      errors,
      attachments,
      isSelectAll,
      downloadAttachmentArr,
      accessPermission,
      reactModalVisible,
      modalMessage,
      emailProvider,
      emailAttachment
    } = this.state;
    return (
      <>
       <ReactModal
          reactModalVisible={reactModalVisible}
          modalMessage={modalMessage}
          submitModal={this.submitModal}
          // requireCancel={requireCancel}
        />
      <div className="box-card" style={{ minHeight: "100%", marginTop: "0px" }}>
        <div id="subCatList">
          <div className="row align-items-center no-gutters ">
            <div className="col-sm-6">
              <h1 className="heading m-b-0">Document List</h1>
            </div>
            {/* {attachments.length ? (
              <div className="col-sm-6 text-right" style={{ width: "45%" }}>
                <label>Select All: </label>
                            <input type="checkbox" style={{marginLeft: '5px'}} 
                            onClick={(e)=>this.isSelectAll(e)} 
                            checked={isSelectAll}
                            />
                {downloadAttachmentArr.length ? (
                  <button
                  className="btn btn-danger m-l-45"
                  onClick={() => this.downloadBulkSubCatAttachment()}
                  disabled={this.state.loadingDownload}
                  href={
                    config.REST_URI +
                    "infoportal?subCatId=" +
                    this.state.category.id +
                    "&attachmentArray=" +
                    this.state.downloadAttachmentArr +
                    "&isBulk=true"
                  }
                >
                  <img src={whiteDownloadSvg} alt="" width="16" style={{ pointerEvents: "none" }} />
                   All
                </button>
                ) : null}
              </div>
            ) : null}
             */}
            <div
              className="row"
              style={{
                display: errors.length === 0 ? "none" : "block",
              }}
            >
              <div className="col-md-12">
                <div className="alert alert-success" role="alert">
                  <div className="row">
                    <span className="danger-link">
                      <DisplayErrors errors={errors} />
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="table-responsive">
              <table className="table table-style-1">
                <thead>
                  <tr>
                    <th scope="col" style={{textAlign:"left"}}>NAME</th>
                    <th scope="col">DESCRIPTION</th>
                    <th scope="col">
                        ACTION 
                      {/* {attachments.length ?<>
                                        {downloadAttachmentArr.length?<input type="checkbox" className="m-l-10" style={{marginTop: '-20px'}} 
                                        onClick={(e)=>this.isSelectAll(e)} 
                                        checked={isSelectAll}
                                        />:null}</>
                                        :null} */}
                    </th>
                    
                  </tr>
                </thead>
                <tbody>
                  {attachments.length
                    ? attachments.map((attachment, index) => {
                        let href =
                          config.REST_URI +
                          "infoportal?attachmentId=" +
                          attachment.id;

                        return (
                          <tr key={index}>
                            <td style={{textAlign:"left"}}>{attachment.name}</td>
                            <td>{attachment.description}</td>
                            <td>
                              {attachment.attachmentType == 2 ? (
                                <a
                                  className="link-click"
                                  href={"/mobile-grid-input"}
                                  data-toggle="tooltip"
                                  data-placement="bottom"
                                  title="Go To Grid"
                                  onClick={() => {
                                    this.onClickOfAttachment(attachment);
                                  }}
                                >
                                  <img src={gridSvg} alt="" />
                                </a>
                              ) : (
                                <>
                                  <a
                                    className="link-click"
                                    href="#"
                                    data-toggle="tooltip"
                                    data-placement="bottom"
                                    title="Download"
                                    // onClick={() =>
                                    //   this.onClickOfAttachment(attachment)
                                    // }
                                    onClick={() => {
                                      if (!this.state.downloadingAttachments[attachment.id]) {
                                        this.onClickOfAttachment(attachment);
                                      }
                                    }}
                                    // href={href}
                                  >
                                      <img
                                        src={downloadSvg}
                                        alt=""
                                        width="16"
                                        style={{
                                          opacity: this.state.downloadingAttachments[attachment.id]
                                            ? 0.5
                                            : 1,
                                        }} // only clicked Download button is disabled
                                      />
                                  </a>
                                  {/* <input type="checkbox" className="m-l-10" style={{marginTop: '-20px'}}
                                            onClick={(e)=>this.isAttachmentDownloadable(e, attachment, index)}
                                                checked={attachment.canDownload} /> */}
                                    {accessPermission &&
                                    accessPermission[245] ? (
                                      <a
                                        className="link-click m-l-10"
                                        href="#"
                                        data-toggle="tooltip"
                                        data-placement="bottom"
                                        title="Email Notification"
                                        
                                        onClick={() =>
                                          this.onModalForEmail(attachment)
                                        }
                                      >
                                        {console.log(
                                          "inside anchor for mobile",
                                          accessPermission[245]
                                        )}

                                        <img
                                          src={Emailnotify}
                                          alt=""
                                          width="16"
                                        />
                                      </a>
                                    ) : null}
                                </>
                              )}
                            </td>
                          </tr>
                        );
                      })
                    : null}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <Modal
          visible={this.state.modalVisibleEmail}
          effect="fadeInDown"
          width="800"
        >
          <div style={{ padding: "20px" }}>
            {/* {console.log("emailattchment" + this.state.emailAttachment)}
            {console.log(
              "emailattchmentname" + this.state.emailAttachment.name
            )} */}
            <div className="modal-content" style={{ border: "none" }}>
              <div
                className="modal-body"
                style={{ paddingTop: 0, display: "" }}
              >
                <div className="col-12" style={{ display: "flex" }}>
                  <figure>
                    <img src={popupLogo} />
                  </figure>
                  <h1 className="heading m-l-10 m-b-35">Send document <span style={{fontStyle:"italic"}}>{this.state.emailAttachment?.name}</span> to below Email/s:</h1>
                </div>

                <div className="col-10">
                  <div className="form-group">
                    <div
                      className="row"
                      style={{
                        display: errors.length === 0 ? "none" : "block",
                      }}
                    >
                      <div className="col">
                        <div className="alert" role="alert">
                          <DisplayErrors errors={errors} />
                        </div>
                      </div>
                    </div>
                    <div className=" ui-widget">
                      <InputComponent
                        required
                        type="text"
                        title="emailId"
                        name="inputEmail"
                        label="Enter valid e-mail"
                        value={emailProvider.inputEmail}
                        placeholder="abc@gmail.com , xyz@gmail.com"
                        handleChange={this.handleChange}
                        validator={this.validator}
                        //validation="required|email"
                        validation="required|multipleEmails"
                      />
                      {this.state.sending && (
                        <p
                          style={{
                            color: "black",
                            fontSize: "17px",
                            marginTop: "",
                            fontWeight:"600"
                            
                          }}
                        >
                          {/* Sending<span className="dot-flashing"></span> */}
                          <div className="uploading-container">
                            <span className="uploading-text">Sending</span>
                            <span className="uploading-dot dot-1">.</span>
                            <span className="uploading-dot dot-2">.</span>
                            <span className="uploading-dot dot-3">.</span>
                          </div>
                        </p>
                      )}
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-default popup-button-default text-w-light"
                    data-dismiss="modal"
                    onClick={() => this.onEmailCancelModalVisible()}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="btn btn-danger popup-button-danger"
                    onClick={() => this.sendEmail(emailAttachment)}
                    disabled={this.state.sending}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </>
    );
  }
}
export default withApollo(Attachments);
